export default {
  apiContactFormPostinId: 'a1cdb6ec-329c-44a3-af06-7fd99c06c02f',
  searchPlaceholder: 'Search in products...',
  searchPlaceholderProducts: 'Search product...',
  yourData: 'Your data:',
  name: 'Name*',
  surname: 'Surname*',
  email: 'Email*',
  phone: 'Phone*',
  city: 'City*',
  role: 'Role',
  requestType: 'Request Type',
  company: 'Company',
  message: 'Message',
  termsExtLabel:
    'I consent to the processing of my personal data as per the information notice and to receive the requested information via email or phone through this form.',
  newsletterExtLabel:
    'I wish to subscribe to the newsletter to stay updated on Bioenologia news (you can unsubscribe at any time through the link in each newsletter you receive)',
  termsError: 'Accept the terms and conditions',
  sendRequest: 'Send request',
  requests: 'Commercial,Support,Other',
  roles: 'Owner,Enologist,Production manager',
  success: 'Request sent successfully',
  error: 'An error has occurred',
  endMessage:
    'Bioenologia will use personal data solely to provide the requested services and will not share it with third parties for advertising purposes. You can request the removal of your data from our systems at any time through this form.',

  // Product contact
  productContact: 'Request information<br> about the product',
  forProduct: 'Selected product:',
  forProducts: 'Selected products:',
  otherProducts: 'Do you want to add other products to your request?',
  otherProductsText:
    'Select them from the list or search for them using the search field below.',
}
